module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/symeon.json
// module id = 624
// module chunks = 18771242582607